import { cn, NoddiIcon, NoddiIconName } from 'noddi-ui-common';
import { commonTexts, toSentenceCase } from 'noddi-util';
import { CardDescription, CardHeader, CardTitle } from '../../base/card';
import { NoddiSkeleton } from '../Feedback/NoddiSkeleton';
import { NoddiTooltip } from '../Overlay/NoddiTooltip';

type Props = {
  title?: string;
  description?: string;
  headerNode?: React.ReactNode;
  icon?: NoddiIconName;
  titleCount?: number;
  /** What `titleCount` is out of, read as "3 of 18" — e.g. while a search narrows a list. */
  titleCountTotal?: number;
  isSmall?: boolean;
  className?: string;
  tooltip?: string | React.ReactNode;
  descriptionSkeleton?: boolean;
  /** Seats the title icon in a washed-brand tile instead of rendering it bare. */
  iconTile?: boolean;
};
export const NoddiCardHeader = ({
  title,
  description,
  headerNode,
  icon,
  titleCount,
  titleCountTotal,
  isSmall,
  className,
  tooltip,
  descriptionSkeleton,
  iconTile
}: Props) => {
  return (
    <CardHeader>
      <div className={cn('flex min-w-0 flex-auto flex-col', isSmall ? 'gap-0' : 'gap-1.5', className)}>
        {title && (
          <div className='flex items-center gap-2'>
            {icon &&
              (iconTile ? (
                <span className='flex size-7 shrink-0 items-center justify-center rounded-md bg-darkPurple30 text-darkPurple'>
                  <NoddiIcon size='small' name={icon} />
                </span>
              ) : (
                <NoddiIcon size={isSmall ? 'xMedium' : 'medium'} name={icon} />
              ))}
            <div className='flex min-w-0 items-baseline gap-2'>
              <CardTitle className={cn('wrap-anywhere', isSmall && 'text-base')}>{toSentenceCase(title)}</CardTitle>
              {titleCount !== undefined && (
                <span className='text-sm text-muted-foreground tabular-nums'>
                  {titleCountTotal === undefined
                    ? titleCount
                    : commonTexts.cardHeader.countOf(titleCount, titleCountTotal)}
                </span>
              )}
            </div>
            {tooltip && <NoddiTooltip content={tooltip} />}
          </div>
        )}
        {descriptionSkeleton ? (
          <NoddiSkeleton className='mt-1 h-4 w-48' />
        ) : (
          description && (
            <CardDescription className='whitespace-pre-line'>
              {description.endsWith('.') ? description.slice(0, -1) : description}
            </CardDescription>
          )
        )}
      </div>
      {headerNode}
    </CardHeader>
  );
};
